module.exports = __webpack_public_path__ + "static/media/bell.fc3da6e2.svg";